import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'de',
    conver: 'de-DE',
    alia: 'de',
    region: 'Germany',
    regionText: 'Deutschland',
    language: 'German',
    languageText: 'Deutsch',
    appId: 7,
    acceptLanguage: 'de-DE,de;q=0.9',
};
export default theLocale;
